/**
 * Time conversion constants (milliseconds)
 *
 * Use these for multi-factor time expressions like ms-to-days conversion.
 * Simple `* 1000` (ms↔s) is universally understood and doesn't need a constant.
 */

export const MS_PER_MINUTE = 60_000;
export const MS_PER_HOUR = 3_600_000;
export const MS_PER_DAY = 86_400_000;
